import { useRoutes } from "react-router-dom";
import Product from "../../../configuration/module/Product/Component/product";
import Category from "./Category/Component/category";
import CheckListBuilder from "./ChecklistConfiguration/Component/checklistBuilder";
import ChecklistBuilderForm from "./ChecklistConfiguration/Component/checklistBuilderForm";

const ConfigurationIndex = () => {
  const router = useRoutes([
    {
      index: true,
      element: <Category />,
    },
    {
      path: "checklist-builder",
      element: <CheckListBuilder />,
    },
    {
      path: "checklist-builder/*",
      children: [
        {
          index: true,
          element: <CheckListBuilder />,
        },
        {
          path: "add",
          element: <ChecklistBuilderForm mode="add" />,
        },
        {
          path: "edit/:id",
          element: <ChecklistBuilderForm mode="edit" />,
        },
        {
          path: "view/:id",
          element: <ChecklistBuilderForm mode="view" />,
        }
      ],
    },
  ]);
  return <div>{router}</div>;
};
export default ConfigurationIndex;
